import { defineMessages } from 'react-intl';

export default defineMessages({
  noFees: {
    id: 'sentinel.components.transferFeesPanel.noFees',
    defaultMessage: 'There are no fees to display. Fees may be still be assessed.',
  },
  ACH_FEE: {
    id: 'sentinel.components.transferFeesPanel.ACH_FEE',
    defaultMessage: 'ACH Fee',
  },
  ACH_NOC_FEE: {
    id: 'sentinel.components.transferFeesPanel.ACH_NOC_FEE',
    defaultMessage: 'ACH NOC Fee',
  },
  ACH_RETURN: {
    id: 'sentinel.components.transferFeesPanel.ACH_RETURN',
    defaultMessage: 'ACH Return Fee',
  },
  ACH_RETURN_UNAPPROVED: {
    id: 'sentinel.components.transferFeesPanel.ACH_RETURN_UNAPPROVED',
    defaultMessage: 'ACH Return Fee - Unapproved',
  },
  ACH_REVERSAL_FEE: {
    id: 'sentinel.components.transferFeesPanel.ACH_REVERSAL_FEE',
    defaultMessage: 'ACH Reversal Fee',
  },
  CHECK_INTERNATIONAL_OVERNIGHT_DELIVERY: {
    id: 'sentinel.components.transferFeesPanel.CHECK_INTERNATIONAL_OVERNIGHT_DELIVERY',
    defaultMessage: 'Check Fee - International Overnight Delivery',
  },
  CHECK_INTERNATIONAL_REGULAR_DELIVERY: {
    id: 'sentinel.components.transferFeesPanel.CHECK_INTERNATIONAL_REGULAR_DELIVERY',
    defaultMessage: 'Check Fee - International Regular Delivery',
  },
  CHECK_OVERNIGHT_DELIVERY: {
    id: 'sentinel.components.transferFeesPanel.CHECK_OVERNIGHT_DELIVERY',
    defaultMessage: 'Check Fee - Overnight Delivery',
  },
  CHECK_OVERNIGHT_TO_BROKER: {
    id: 'sentinel.components.transferFeesPanel.CHECK_OVERNIGHT_TO_BROKER',
    defaultMessage: 'Check Fee - Overnight To Broker Delivery',
  },
  CHECK_PRINT_AT_FIRM: {
    id: 'sentinel.components.transferFeesPanel.CHECK_PRINT_AT_FIRM',
    defaultMessage: 'Check Fee - Print at Firm',
  },
  CHECK_STOP_PAYMENT: {
    id: 'sentinel.components.transferFeesPanel.CHECK_STOP_PAYMENT',
    defaultMessage: 'Check Fee - Stop Payment',
  },
  CHECK_REGULAR_DELIVERY: {
    id: 'sentinel.components.transferFeesPanel.CHECK_REGULAR_DELIVERY',
    defaultMessage: 'Check Fee - Regular Delivery',
  },
  CHECK_SATURDAY_DELIVERY: {
    id: 'sentinel.components.transferFeesPanel.CHECK_SATURDAY_DELIVERY',
    defaultMessage: 'Check Fee - Saturday Delivery',
  },
  CLOSING: {
    id: 'sentinel.components.transferFeesPanel.CLOSING',
    defaultMessage: 'IRA Closing Fee',
  },
  DOMESTIC_WIRE: {
    id: 'sentinel.components.transferFeesPanel.DOMESTIC_WIRE',
    defaultMessage: 'Wire Withdrawal Fee - Domestic',
  },
  DOMESTIC_WIRE_DEPOSIT: {
    id: 'sentinel.components.transferFeesPanel.DOMESTIC_WIRE_DEPOSIT',
    defaultMessage: 'Wire Deposit Fee - Domestic',
  },
  INTERNATIONAL_WIRE: {
    id: 'sentinel.components.transferFeesPanel.INTERNATIONAL_WIRE',
    defaultMessage: 'Wire Withdrawal Fee - International',
  },
  INTERNATIONAL_WIRE_DEPOSIT: {
    id: 'sentinel.components.transferFeesPanel.INTERNATIONAL_WIRE_DEPOSIT',
    defaultMessage: 'Wire Deposit Fee - International',
  },
  MICRO_ACH_FEE: {
    id: 'sentinel.components.transferFeesPanel.MICRO_ACH_FEE',
    defaultMessage: 'ACH Micro ACH Fee',
  },
  MICRO_NOC_FEE: {
    id: 'sentinel.components.transferFeesPanel.MICRO_NOC_FEE',
    defaultMessage: 'ACH Micro NOC Fee',
  },
  MICRO_RETURN: {
    id: 'sentinel.components.transferFeesPanel.MICRO_RETURN',
    defaultMessage: 'ACH Micro Return Fee',
  },
  MICRO_RETURN_UNAPPROVED: {
    id: 'sentinel.components.transferFeesPanel.MICRO_RETURN_UNAPPROVED',
    defaultMessage: 'ACH Micro Return Fee - Unapproved',
  },
  PRE_PAY: {
    id: 'sentinel.components.transferFeesPanel.PRE_PAY',
    defaultMessage: 'Pre-Pay Fee',
  },
  PAYPAL_DEPOSIT_FEE: {
    id: 'sentinel.components.transferFeesPanel.PAYPAL_DEPOSIT_FEE',
    defaultMessage: 'PayPal Deposit Fee',
  },
  PAYPAL_WITHDRAWAL_FEE: {
    id: 'sentinel.components.transferFeesPanel.PAYPAL_WITHDRAWAL_FEE',
    defaultMessage: 'PayPal Withdrawal Fee',
  },
  RTP_DEPOSIT: {
    id: 'sentinel.components.transferFeesPanel.RTP_DEPOSIT',
    defaultMessage: 'RTP Deposit Fee',
  },
  RTP_WITHDRAWAL: {
    id: 'sentinel.components.transferFeesPanel.RTP_WITHDRAWAL',
    defaultMessage: 'RTP Withdrawal Fee',
  },
});



// WEBPACK FOOTER //
// ./src/components/TransferFeesPanel/messages.js